import {
  Plus,
  Trash,
  CaretUp,
  CaretDown,
} from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const TYPE_OPTIONS = [
  { value: "scale", label: "Scala 1-10" },
  { value: "number", label: "Numero" },
  { value: "text", label: "Testo libero" },
];

function QuestionRow({ q, idx, totalCount, onUpdate, onMove, onRemove }) {
  const isCustom = q.key.startsWith("custom_");
  return (
    <div
      className={`grid grid-cols-[auto_1fr_120px_auto_auto] gap-2 items-center bg-[#0A0A0A] border border-[#1A1A1A] rounded-lg px-3 py-2 ${
        q.enabled ? "" : "opacity-60"
      }`}
      data-testid={`checkin-question-${q.key}`}
    >
      <div className="flex flex-col">
        <button
          type="button"
          onClick={() => onMove(idx, -1)}
          className="text-zinc-600 hover:text-white disabled:opacity-30"
          disabled={idx === 0}
          aria-label="Sposta su"
        >
          <CaretUp size={12} />
        </button>
        <button
          type="button"
          onClick={() => onMove(idx, 1)}
          className="text-zinc-600 hover:text-white disabled:opacity-30"
          disabled={idx === totalCount - 1}
          aria-label="Sposta giù"
        >
          <CaretDown size={12} />
        </button>
      </div>
      <Input
        value={q.label}
        onChange={(e) => onUpdate(idx, { label: e.target.value })}
        className="bg-[#171717] border-[#262626] text-white text-sm h-8"
        placeholder="Etichetta domanda"
      />
      <select
        value={q.type}
        onChange={(e) => onUpdate(idx, { type: e.target.value })}
        className="bg-[#171717] border border-[#262626] text-white text-xs rounded px-2 h-8 cursor-pointer hover:border-[#333]"
      >
        {TYPE_OPTIONS.map((t) => (
          <option key={t.value} value={t.value}>{t.label}</option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => onUpdate(idx, { enabled: !q.enabled })}
        className={`text-xs px-2 py-1 rounded font-medium ${
          q.enabled
            ? "bg-[#34C759]/15 text-[#34C759]"
            : "bg-[#171717] border border-[#262626] text-zinc-500"
        }`}
        data-testid={`checkin-question-toggle-${q.key}`}
      >
        {q.enabled ? "ON" : "OFF"}
      </button>
      <button
        type="button"
        onClick={() => onRemove(idx)}
        className="text-zinc-600 hover:text-red-400 disabled:opacity-30"
        disabled={!isCustom}
        title={isCustom ? "Rimuovi" : "Le domande standard non sono rimovibili (puoi disattivarle)"}
        aria-label="Rimuovi domanda"
      >
        <Trash size={14} />
      </button>
    </div>
  );
}

export default function CheckinQuestionsEditor({
  questions,
  saving,
  onUpdateQuestion,
  onMoveQuestion,
  onRemoveQuestion,
  onAddQuestion,
  onSave,
}) {
  return (
    <div className="bg-[#171717] border border-[#262626] rounded-lg p-5" data-testid="checkin-questions-editor">
      <div className="flex items-center justify-between mb-4">
        <h4
          className="text-sm font-bold tracking-tight uppercase text-white"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          DOMANDE
        </h4>
        <div className="flex gap-2">
          <Button
            onClick={onAddQuestion}
            variant="outline"
            size="sm"
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A] hover:text-white"
            data-testid="checkin-add-question"
          >
            <Plus size={14} className="mr-1" /> Domanda
          </Button>
          <Button
            onClick={onSave}
            disabled={saving}
            size="sm"
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="checkin-save-questions"
          >
            Salva
          </Button>
        </div>
      </div>
      <div className="space-y-2">
        {questions.map((q, idx) => (
          <QuestionRow
            key={q.key}
            q={q}
            idx={idx}
            totalCount={questions.length}
            onUpdate={onUpdateQuestion}
            onMove={onMoveQuestion}
            onRemove={onRemoveQuestion}
          />
        ))}
      </div>
      <p className="text-[11px] text-zinc-600 mt-3">
        Tip: le domande standard sono disattivabili (toggle ON/OFF) ma non eliminabili. Per
        metriche specifiche aggiungi una domanda custom (es. "Passi medi", "Ore di studio",
        "Bicchieri d'acqua").
      </p>
    </div>
  );
}
